import { Component } from "react";
import Window from "../ui/Window";
import { MdCalendarViewWeek } from "react-icons/md";
import {
    Box,
    Stack
} from "@mui/system";

import {
    Card,
    CircularProgress,
    Grid,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem
} from "@mui/material";

import Cookies from "universal-cookie";
import { httpGet } from "../util/http";
import { Navigate } from "react-router-dom";

export default class RelatorioSemanal extends Component {

    constructor(props) {
        super(props);

        let cookies = new Cookies();

        this.user = cookies.get('user');

        this.state = {
            loading: false,
            ano: new Date().getFullYear(),
            dados: [],
            toHome: !this.user.isAdmin
        };
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {

        this.setState({
            loading: true
        });

        httpGet(
            '/relatorios/semanal?ano=' + this.state.ano,
            data => {
                this.setState({
                    dados: data.dados,
                    loading: false
                });
            },

            error => {
                console.log(error);
                this.setState({
                    loading: false
                });
            },
            false
        );
    }

    getColor(percentual) {
        if (percentual >= 100)
            return '#4caf50';

        if (percentual >= 50)
            return '#ff9800';

        if (percentual >= 10)
            return '#f44336';

        return 'lightgray';
    }

    renderMes(mes) {
        const cor = this.getColor(mes.percentual);
        return (
            <Stack direction="row" spacing={1} alignItems="center">
                <Box
                    sx={{
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        backgroundColor: cor,
                        flexShrink: 0
                    }}
                />
                <Typography variant="caption">
                    {mes.realizadas}/{mes.previstas}
                </Typography>
                <Typography
                    variant="caption"
                    color="lightgray"
                >
                    ({mes.percentual}%)
                </Typography>
            </Stack>
        );
    }

    render() {
        return (
            <>
                {this.user.isAdmin &&
                    <Window full title="Relatório de Desempenho" icon={MdCalendarViewWeek}>
                        <Stack>
                            <Typography mt={1} fontSize={11}>Selecione o ano para ver a meta mensal dos depósitos.</Typography>
                            <Card sx={{ padding: 1 }} elevation={0}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item>
                                        <Select size="small" value={this.state.ano}
                                            onChange={e => {

                                                this.setState({
                                                    ano: e.target.value
                                                }, () => {
                                                    this.refresh();
                                                });
                                            }}
                                        >
                                            <MenuItem value={2026}>2026</MenuItem>
                                            <MenuItem value={2027}>2027</MenuItem>
                                            <MenuItem value={2028}>2028</MenuItem>
                                            <MenuItem value={2029}>2029</MenuItem>
                                        </Select>
                                    </Grid>
                                </Grid>
                            </Card>

                            <Card elevation={0}>
                                {this.state.loading && <Box sx={{ padding: 5, textAlign: 'center' }}><CircularProgress /></Box>}
                                {!this.state.loading &&
                                    <TableContainer component={Paper} sx={{ width: '100%', maxHeight: '78vh', overflowX: 'auto', overflowY: 'auto' }}>
                                        <Table stickyHeader size="small" sx={{ minWidth: 1200, tableLayout: 'fixed' }}>
                                            <TableHead sx={{
                                                '& th': {
                                                    color: 'primary.main',
                                                    backgroundColor: 'mariano.secondary',
                                                    zIndex: 1
                                                }
                                            }}>
                                                <TableRow>
                                                    <TableCell>
                                                        <b>Depósito</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Jan</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Fev</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Mar</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Abr</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Mai</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Jun</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Jul</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Ago</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Set</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Out</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Nov</b>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <b>Dez</b>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.dados.map((deposito, index) => (
                                                        <TableRow key={index} hover>
                                                            <TableCell>
                                                                <Typography variant="caption">{deposito.deposito}</Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[1])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[2])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[3])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[4])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[5])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[6])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[7])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[8])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[9])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[10])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[11])}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.renderMes(deposito.meses[12])}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Stack>
                    </Window>
                }
                {this.state.toHome && <Navigate to='/' />}
            </>
        );
    }
}